import { fromJS } from 'immutable'
import {
  POSITION_EXPORT_REQUEST,
  POSITION_EXPORT_SUCCESS,
  POSITION_EXPORT_FAILURE,
  POSITION_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case POSITION_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case POSITION_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case POSITION_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case POSITION_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/position/position-export-reducer.js